import React from 'react'
import styled from 'styled-components'
import bgImageUrl from '../../assets/images/Preview.png'
import bgImageUrlDark from '../../assets/images/preview_dark.png'
import logoPlaceholder from '../../assets/images/logoPlaceholder.png'
import previewShape from '../../assets/images/previewShapes.png'


import StyledText from '../../components/StyledComponents/StyledText'
import { useTheme } from '../../middleware/ThemeContext'
import { Button } from '../../components/form/Button'
import { WebsiteFormValues } from '../../types/types'
const LivePreview = ({ websiteDetails, isResponsive }: { websiteDetails: WebsiteFormValues, isResponsive?: boolean }) => {
    const { theme } = useTheme();    
    return (
        <Container backgroundImage={theme.name === 'light' ? bgImageUrl : bgImageUrlDark}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0px 95px'
            }}>
                <div className='d-flex flex-column' style={{paddingTop:73}}>

                    <img src={websiteDetails?.logoPreview || logoPlaceholder} alt="logo" width={websiteDetails?.logoPreview ? 25 : 66} height={websiteDetails?.logoPreview ? 25 : 'auto'} style={{ borderRadius: 5, objectFit: 'contain' }} />
                    <div className='d-flex gap-2 ' >
                        <div className='d-flex flex-column gap-2'>
                            <StyledText className='mt-2' fontSize={"11px"} fontWeight={700} textColor={websiteDetails?.primaryColor} fontFamily={websiteDetails?.fontFamily}>
                                Hero Section Main Title Goes Here
                            </StyledText>

                            <StyledText fontSize="8px" fontWeight={400} textColor={websiteDetails?.textColor} lineHeight='1.5' fontFamily={websiteDetails?.fontFamily}>
                                Lorum ipsum description goes here with
                                some dummy text that will go live on the
                                website hero section
                            </StyledText>
                            <Button
                                theme={theme}
                                btnBg={websiteDetails?.primaryColor}
                                color={theme?.CorporateTheme?.colors?.background}
                                type="button"
                                $variant="customButton"
                                className={`px-3 mt-1`}
                                fontSize='10px'
                                radius='9px'
                                height='26'
                                width='100px'
                                borderColor='none'
                                fontFamily={websiteDetails.fontFamily}


                            >
                                Get Started
                            </Button>
                        </div>
                        <div>
                            <img src={previewShape} height={isResponsive ? 100 : 151} />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

const Container = styled.div<{ backgroundImage?: string }>`
  width: 100%;
  aspect-ratio: 16 / 9;   /* responsive height */

  background-image: url(${(props) => props.backgroundImage || 'https://your-default-bg.jpg'});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

`;

export default LivePreview
